/**
 * Menu store.
 *
 */

import { Module, VuexModule, getModule, Mutation, Action } from 'vuex-module-decorators';
import store from '@/store';
import { menuItems } from './items';

import { MenuItems } from '@/types/menuItem';
import UserModule from '@/store/user';

export const MODULE_NAME = 'menu';

@Module({ dynamic: true, store, name: MODULE_NAME, namespaced: true })
class MenuModule extends VuexModule {
    menuItems: MenuItems = {};

    constructor(module: MenuModule) {
        super(module);
    }

    @Mutation
    SET_MENU_ITEMS(items: MenuItems) {
        this.menuItems = items;
    }

    @Mutation
    SET_MENU_ITEM_PROP(params: { itemName: string; prop: string; value: string }) {
        if (!this.menuItems[params.itemName]) {
            return;
        }

        (this.menuItems[params.itemName] as any)[params.prop] = params.value;
    }

    @Action({ rawError: true })
    initMenuItems() {
        const menuByUser: MenuItems = {};
        for (const [menuItemKey, menuItem] of Object.entries(menuItems)) {
            if (UserModule.role && menuItem.roles.includes(UserModule.role)) {
                menuByUser[menuItemKey] = menuItem;
            }
        }

        this.SET_MENU_ITEMS(menuByUser);
    }
}

export default getModule(MenuModule);
